module.exports = __webpack_public_path__ + "img/5f_r_belmont.6c885a1f.jpg";